module.exports = __webpack_public_path__ + "static/grandprize-prize-games-0f6eeb1638defb411146e5c66a1ba73c.png";